import React from 'react';
import styled from 'styled-components';
import {FormControlStructure} from '../../FormControlStructure';
import {Input} from '../../input/Input';
import {scrollBar} from '../../../../../shared-components/mixin/scroll/scrollBar';
import {colorTheme} from '../../../../mixin/colorTheme';

export const TextAreaWrapper = styled(Input.Wrapper)``;

export const TextAreaStructure = ({name, disabled, label, styleFile, children, code, errorMessage}) => (
    <FormControlStructure styleFile={styleFile} label={label} name={name} errorMessage={errorMessage}>
        <Wrapper code={code}>
            <TextAreaWrapper disabled={disabled}>{children}</TextAreaWrapper>
        </Wrapper>
    </FormControlStructure>
);

const Wrapper = styled.div`
    ${colorTheme({
        //== scroll ===
        '--scroll-bar-background ': {
            dark: 'var(--form-control-background-color)                         ',
            light: 'var(--purple-00)',
        },
        '--scroll-bar-border     ': {
            dark: 'var(--scroll-bar-background )   ',
            light: 'var(--scroll-bar-background )',
        },
        '--scroll-bar-thumb      ': {
            dark: 'var(--black-13)                             ',
            light: 'var(--white-00)',
        },
        '--scroll-bar-thumb-hover': {
            dark: 'var(--black-03)                            ',
            light: 'var(--scroll-bar-background )',
        },

        // // === Mozilla mod === // //
        '--scroll-bar-background-moz      ': {
            dark: 'var(--black-03)                              ',
            light: 'var(--white-00)',
        },
        '--scroll-bar-thumb-moz ': {dark: 'var(--black-14)                          ', light: 'var(--purple-00)'},
    })};

    ${TextAreaWrapper},
    textarea {
        height: unset;
        display: block;
        width: 100%;
    }
    textarea {
        background: none;
        border: none;
        padding-top: 12px;
        padding-bottom: 12px;

        overflow-y: auto;
        ${scrollBar};
        font-weight: 400;
        padding-top: 8px;
        &:focus {
            outline: none;
        }
    }
    ${({code}) => {
        if (code)
            return `
            textarea{
                font-family: monospace!important;
            }
        `;
        else
            return `
            textarea{
                font-family: 'RobotoFont'!important;
            }
        `;
    }}
`;
